const SYMBOL_MAP = { USD: '$', EUR: '€', GBP: '£' };

export const getCurrencySymbol = (currencyCode: keyof typeof SYMBOL_MAP): string => SYMBOL_MAP[currencyCode];

export const stripeIntegerToPrismaDecimal = (amount: number) => {
  return (amount / 100).toFixed(2);
};
